import { ReduxState } from "../store";

export const selectUserId = (state: ReduxState) => state.auth.userId;
export const selectIsLoggedIn = (state: ReduxState) => state.auth.isLoggedIn;
export const selectFetchStatus = (state: ReduxState) => state.auth.fetchStatus;
export const selectLogOutModal = (state: ReduxState) => state.auth.logOutModal;
export const selectLoggingOut = (state: ReduxState) => state.auth.loggingOut;
export const selectAccessToProtectedRoutes = (state: ReduxState) => state.auth.accessToProtectedRoutes;
